// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2rQUg","savePackageButton":"ClientWallet_savePackageButton__2X03P"};